/* eslint-disable */
export default {
  currentCall: 'Chamada atual',
  viewCalls: 'Ver chm',
  view: 'Ver',
  incomingCall: '{numberOf} ch. recebida',
  incomingCalls: '{numberOf} ch. recebidas',
  callOnHold: '{numberOf} chm em espera',
  callsOnHold: '{numberOf} chm em espera',
  otherDeviceCall: '{numberOf} ch. noutros disp.',
  otherDeviceCalls: '{numberOf} ch. noutros disp.',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
